/* eslint-disable max-len */
import * as utils from '../styleUtils';
import { SLF_SEL } from '../constants';

const { makeASlightlyDifferentColor } = utils;

export default function (designSettings = {}) {
    const { dashboards = {} } = designSettings;
    const {
        widgetTextColor,
        widgetSecondaryTextColor,
        widgetBackgroundColor,
        widgetTitleBackgroundColor,
    } = dashboards;

    const widgetBackSecondaryColor = makeASlightlyDifferentColor(widgetBackgroundColor);

    const style = {
        [SLF_SEL.WIDGET_BACK_SECONDARY]: {
            backgroundColor: widgetBackSecondaryColor,
        },
        [SLF_SEL.WIDGET_BACK]: {
            backgroundColor: widgetBackgroundColor,
        },
        [SLF_SEL.WIDGET_TITLE_BACK]: {
            backgroundColor: widgetTitleBackgroundColor,
        },
        [`${SLF_SEL.WIDGET_TEXT_PRIMARY_HOV},
          ${SLF_SEL.WIDGET_TEXT_PRIMARY}`]: {
            fill: widgetTextColor,
            color: widgetTextColor,
        },
        [`${SLF_SEL.WIDGET_TEXT_SECONDARY_HOV},
          ${SLF_SEL.WIDGET_TEXT_PRIMARY_HOV}:hover,
          ${SLF_SEL.WIDGET_TEXT_SECONDARY}`]: {
            fill: widgetSecondaryTextColor,
            color: widgetSecondaryTextColor,
        },
        [`${SLF_SEL.TEXT_SECONDARY_HOVER}:hover`]: {
            fill: widgetTextColor,
            color: widgetTextColor,
        },
    };
    return style;
}
